import * as React from "react";
import "./presenter.scss";
import User from "../../../../model/user/User";
import {Option} from "ts-option";
import {RootState} from "../../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import UserInitials from "../../common/userInitials/UserInitials";
import {getUserByOptionalId} from "../../../../store/view/user";
import {Icon} from "../../../../hiberUiKit/src/atoms/Icon/Icon";
import IconLarge from "../../../../hiberUiKit/src/atoms/Icon/IconLarge";

interface IPresenterProps {
	/**
	 * Agent Id
	 */
	agentId: Option<string>;
	/**
	 * Bdp id
	 */
	bdpId: Option<string>;
}

interface IReduxProps {
	/**
	 * Agent
	 */
	agent: Option<User>;
	/**
	 * Bdp
	 */
	bdp: Option<User>;
}

type PresenterProps = IPresenterProps & IReduxProps;

class AssigneesPresenterComponent extends React.Component<PresenterProps, {}> {
	render() {
		return (
			<div className={"presenter-assignees"}>
				{this.props.agent.map(u => <UserInitials user={u} isActive={!u.disabled}/>)
					.getOrElse(
						<div className={"presenter-assignees_empty"}>
							<IconLarge icon={Icon.Agent} variant={"lightGray"}/>
						</div>)
				}
				{this.props.bdp.map(u => <UserInitials user={u} isActive={!u.disabled}/>)
					.getOrElse(
						<div className={"presenter-assignees_empty"}>
							<IconLarge icon={Icon.Spanner} variant={"lightGray"}/>
						</div>)
				}
			</div>
		);
	}
}

function mapStateToProps(state: RootState, props: IPresenterProps) {
	return {
		agent: getUserByOptionalId(props.agentId),
		bdp: getUserByOptionalId(props.bdpId)
	}
}

export default connect<IReduxProps, null, IPresenterProps>(mapStateToProps)(AssigneesPresenterComponent);